module.exports = __webpack_public_path__ + "img/venus_media_collection.179f4ab8.svg";